import React from "react"

import { CheckboxProps } from "@mui/material"

export const createCheckboxClickHandler = (
  checkboxProps?: CheckboxProps
): React.MouseEventHandler<HTMLDivElement> => {
  return (e) => {
    if ((e.target as HTMLElement).tagName !== "INPUT" && checkboxProps?.onChange) {
      e.preventDefault()
      e.stopPropagation()
      checkboxProps.onChange(
        { target: { checked: !checkboxProps.checked } } as React.ChangeEvent<HTMLInputElement>,
        !checkboxProps.checked
      )
    }
  }
}
